import { Button } from 'primereact/button';
import { Invite } from './colDefsInvitesTable';

export const OptionCell = (props: { data: Invite }) => {
  return (
    <Button
      label="Revoke"
      severity="warning"
      size="small"
      style={{ height: '28px' }}
      onClick={() => props.data.handleRevoke()}
    />
  );
};
